import { IntelWorkspaceItem } from '@pn/core/domain/intel/intel-workspace-item.ts';
import { IIntelDataProvider } from '@pn/core/providers/intel/ports';
import { apiDataItemMapper } from '@pn/services/api/data/apiDataItemMapper.ts';
import { pnApiClient } from '@pn/services/api/pnApiClient';
import { ApiQuery } from '@pn/services/api/query/types.ts';
import { isNil } from 'lodash-es';
import { ApiIntelItem } from './types';

// TODO: Undo the sins
export const requestData = async (
  intelWorkspaceItem: IntelWorkspaceItem,
  geographyFilter: GeoJSON.Geometry | null,
  province: string | null
) => {
  const {
    query: { dataType, filters, filtersLinkOperator, sorts, limit },
    mapping,
  } = intelWorkspaceItem;
  // TODO: ugly hack for the joined table of this endpoint
  let modifiedFilters = [...filters];
  if (!isNil(province) && isNil(intelWorkspaceItem.linkedReportId)) {
    if (
      dataType === 'well_licenses' ||
      dataType.includes('ip3') ||
      dataType.includes('ip12') ||
      dataType.includes('wells_by')
    ) {
      modifiedFilters.push({
        field: 'wellbores.province',
        operator: '=',
        value: province,
        unitSystem: undefined,
      });
    } else if (dataType === 'well_license_transfers') {
      modifiedFilters.push({
        field: 'license_transfers_by_company.province',
        operator: '=',
        value: province,
        unitSystem: undefined,
      });
    } else if (dataType === 'land_results' || dataType === 'land_postings') {
      modifiedFilters.push({
        field: 'market_intel_land_postings.province',
        operator: '=',
        value: province,
        unitSystem: undefined,
      });
    } else {
      modifiedFilters.push({
        field: 'province',
        operator: '=',
        value: province,
        unitSystem: undefined,
      });
    }
  }

  if (dataType === 'aer_transfers') {
    const provinceFilter = modifiedFilters.find(
      ({ field }) => field === 'province'
    );
    if (!isNil(provinceFilter)) {
      if (provinceFilter?.value !== 'AB') {
        return [];
      }
      modifiedFilters = modifiedFilters.filter(
        ({ field }) => field !== 'province'
      );
    }
  }

  if (!isNil(geographyFilter) && isNil(intelWorkspaceItem.linkedReportId)) {
    const wellboresDataTypes = [
      'well_licenses',
      'liquid_ip3',
      'liquid_ip12',
      'gas_ip3',
      'gas_ip12',
      'wells_by_production',
      'wells_by_gas_production',
      'wells_by_liquid_production',
    ];
    if (wellboresDataTypes.includes(dataType)) {
      modifiedFilters.push({
        field: 'wellbores.geom',
        operator: 'intersects',
        value: geographyFilter,
        unitSystem: undefined,
      });
    } else if (dataType === 'expired_minerals' || dataType === 'zone_changes') {
      modifiedFilters.push({
        field: 'mineral_rights_geometries.land_geom',
        operator: 'intersects',
        value: geographyFilter,
        unitSystem: undefined,
      });
    } else {
      modifiedFilters.push({
        field: 'geom',
        operator: 'intersects',
        value: geographyFilter,
        unitSystem: undefined,
      });
    }
  }

  const payload: ApiQuery = {
    fields: [],
    requested_ids: [],
    filters: modifiedFilters,
    filters_link_operator: filtersLinkOperator,
    sorts,
  };
  payload.limit = intelWorkspaceItem.query.limit;

  let response: any[];
  // TODO: consolidate this into a single endpoint and undo this switch statement
  switch (dataType) {
    case 'liquid_ip3':
    case 'liquid_ip12':
    case 'gas_ip3':
    case 'gas_ip12':
      response = await pnApiClient.request<ApiIntelItem[]>({
        url: `v2/wells/top_wells_by_ip/${dataType}`,
        method: 'POST',
        payload,
      });
      break;
    case 'wells_by_production':
      response = await pnApiClient.request<ApiIntelItem[]>({
        url: `v2/wells/top_producing/boe?limit=${limit}`,
        method: 'POST',
        payload,
      });
      break;
    case 'wells_by_gas_production':
      response = await pnApiClient.request<ApiIntelItem[]>({
        url: `v2/wells/top_producing/gas?limit=${limit}`,
        method: 'POST',
        payload,
      });
      break;
    case 'wells_by_liquid_production':
      response = await pnApiClient.request<ApiIntelItem[]>({
        url: `v2/wells/top_producing/liquid?limit=${limit}`,
        method: 'POST',
        payload,
      });
      break;
    default:
      // this is the endpoint we want to consolidate to eventually
      response = await pnApiClient.request<any[]>({
        url: `v2/data/${dataType}`,
        method: 'POST',
        payload,
      });
  }

  return response.map(apiDataItemMapper(mapping).toDomainDataItem);
};

export const apiIntelDynamicDataProvider: IIntelDataProvider = {
  getData: requestData,
};
